import { Container, Item } from './styled';
import Praia from '../../../assets/Destinations/praia.png'
import Urbano from '../../../assets/Destinations/urbano.png'
import Rural from '../../../assets/Destinations/rural.png'
import { Link } from 'react-router-dom';

import ArrowBack from '../../../components/ArrowBack';

const Destination1 = () => {
    return (
        <>
            <ArrowBack to="/"/>
            <Container>
                <h2>Para onde gostaria de ir?</h2>
                <p>Escolha a <b>estadia ideal</b> para suas próximas férias, parceladas em <b>24x.</b></p>
                <div className='grid'>
                    <Link to={{pathname: '/destination2/1', category_id: 1}}><Item><div><img src={Praia} alt='Praia' /></div><h2>Praia</h2></Item></Link>
                    <Link to={{pathname: '/destination2/2', category_id: 2}}><Item><div><img src={Urbano} alt='Cidade' /></div><h2>Cidade</h2></Item></Link>
                    <Link to={{pathname: '/destination2/3', category_id: 3}}><Item><div><img src={Rural} alt='Campo' /></div><h2>Campo</h2></Item></Link>
                </div>
            </Container>
        </>
    );
}

export default Destination1;